import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
	ACTUAL_IMAGE_URL,
	API_URL,
	COMPRESSED_IMAGE_URL,
	config,
	formConfig,
} from '../../../config/config';
import FilterSectionStoke from './FilterSectionForStoke';
import {
	// getFetchStockTable,
	getFetchStockTableForAdmin,
	getFetchStockDetailTableForAdmin,
	getFetchCatalogImage,
	getDropdownColor,
	getDropdownSize,
	deleteArticleDesignById,
} from '../../../Redux/features/Stock/stockSlice';
import { DROPDOWN_FLAG } from '../../../config/config';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosArrowDown } from 'react-icons/io';
import { ImCancelCircle } from 'react-icons/im';
import { IoEye, IoAddCircle } from 'react-icons/io5';
import { ImCross } from 'react-icons/im';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { AiFillDelete } from 'react-icons/ai';
import { RiPlayListAddFill } from 'react-icons/ri';
import { MdImageNotSupported } from 'react-icons/md';
import no_article from '../../images/no_product.png';

const Skeleton = () => (
	<>
		{/* Skeleton Rows */}
		{[...Array(8)].map((_, index) => (
			<tr key={index} className='w-full animate-pulse border'>
				<td className='py-1 px-4'>
					<div className=' w-16 h-16 bg-gray-300 rounded mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded  w-60 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className=''>
					<div className=' h-14 bg-gray-300 rounded w-14 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-36 mx-auto'></div>
				</td>
			</tr>
		))}
	</>
);

const compressImage = async (file) => {
	if (file.size <= 500 * 1024) {
		return file;
	}

	const img = document.createElement('img');
	img.src = URL.createObjectURL(file);
	await new Promise((resolve) => (img.onload = resolve));

	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d');
	const scale = 0.5;
	canvas.width = img.width * scale;
	canvas.height = img.height * scale;
	context.drawImage(img, 0, 0, canvas.width, canvas.height);

	return new Promise((resolve) => {
		canvas.toBlob(
			(blob) => {
				resolve(new File([blob], file.name, { type: file.type }));
			},
			file.type,
			1.0
		);
	});
};

const ManageArticle = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const path = location.pathname;
	const normalizePath = (url) => url.replace(/\/$/, '');
	const currentPath = normalizePath(path);
	const [selectedImages, setSelectedImages] = useState([]);
	const [catalogImages, setCatalogImages] = useState([]);
	const [isCatalogModalOpen, setIsCatalogModalOpen] = useState(false);
	const [stockDetails, setStockDetails] = useState([]);
	const [designData, setDesignData] = useState({});
	const queryParams = new URLSearchParams(location.search);
	const pageFromUrl = queryParams.get('page');
	const initialPage = pageFromUrl ? parseInt(pageFromUrl, 10) : 1;
	const { stockTable } = useSelector((state) => state.stock);
	const totalPages = stockTable?.totalPages;
	const allStock = stockTable?.allStock;
	const [isTableLoading, setIsTableLoading] = useState(true);
	const [hasFetched, setHasFetched] = useState(false);
	const [fileName, setFileName] = useState(null);
	const [currentPage, setCurrentPage] = useState(initialPage);

	const [Filter, setFilter] = useState({
		// ArticleCode: '',
		ProductId: 0,
		Category: '',
		SubCategory: '',
		IsDisplayOnPortal: 1,
	});

	const handleStokeFilter = () => {
		setCurrentPage(1);
		getFetchStockTableForAdmin(1);
		dispatch(getFetchStockTableForAdmin({ data: Filter, page: 1 }));
	};
	const handleReset = () => {
		setFilter({
			ArticleCode: '',
			ProductId: 0,
			Category: '',
			SubCategory: '',
			IsDisplayOnPortal: '',
		});
		dispatch(getFetchStockTableForAdmin({ page: 1 }));
		setCurrentPage(1);
	};

	useEffect(() => {
		const areFiltersEmpty = !Object.values(Filter).some(Boolean);

		if (stockTable?.length === 0 && !hasFetched && !areFiltersEmpty) {
			setIsTableLoading(true);
			dispatch(getFetchStockTableForAdmin({ page: currentPage, data: Filter })).then(() => {
				setIsTableLoading(false);
			});

			setHasFetched(true);
		} else {
			setIsTableLoading(false);
		}
	}, [dispatch, stockTable?.length, currentPage, Filter, hasFetched]);

	const [modal, setModal] = useState(false);

	const [imageDetails, setImageDetails] = useState({
		currentImage: '',
		ArticleCode: '',
		showImage: false,
	});

	const handleImageClick = (image, Id) => {
		setImageDetails({
			currentImage: image,
			Id: Id,
		});
		setModal(true);
	};

	const handlecloseModal = () => {
		setImageDetails({
			currentImage: '',
			Id: '',
		});
		setModal(false);
	};

	const [parentImageModal, setParentImageModal] = useState(false);

	const [parentImageDetails, setParentImageDetails] = useState({
		currentImage: '',
		Id: '',
		showImage: false,
	});

	const handleParentImageClick = (image, Id) => {
		setParentImageDetails({
			currentImage: image,
			Id: Id,
			showImage: false,
		});
		setParentImageModal(true);
	};

	const handleParentImageChange = (e) => {
		const file = e.target.files[0];
		if (file && file.size > 10 * 1024 * 1024) {
			toast.error('File size exceeds the 10MB limit. Please choose a smaller file.');
			return;
		}
		setFileName(file);
		setParentImageDetails((prevState) => ({
			...prevState,
			currentImage: URL.createObjectURL(file),
			showImage: true,
		}));
	};

	const handleCloseParentModal = () => {
		setParentImageDetails({
			currentImage: '',
			Id: '',
			showImage: false,
		});
		setParentImageModal(false);
	};

	const handleParentImageSubmit = async (Id) => {
		if (!fileName) return console.error('No image selected');

		try {
			const compressedImage = await compressImage(fileName);

			const uploadData = new FormData();
			uploadData.append('originalImage', fileName);
			uploadData.append('compressedImage', compressedImage);
			uploadData.append('Id', Id);

			const response = await axios.post(
				`${API_URL}/addStock/updateParantImage`,
				uploadData,
				formConfig
			);

			if (response.data.success) {
				dispatch(getFetchStockTableForAdmin({ page: currentPage, data: Filter }));

				handleCloseParentModal();

				toast.success(`Product image ${response.data.message}`);
			} else {
				toast.error(response.data.message);
			}
		} catch (error) {
			toast.error(error.response?.data?.message || 'Error updating image');
		}
	};

	const [addDesign, setAddDesign] = useState(false);

	const addDesignModal = (Id) => {
		setAddDesign(true);
	};

	const closeAddDesignModal = () => {
		setAddDesign(false);
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			const newPage = currentPage + 1;
			setCurrentPage(newPage);
			dispatch(getFetchStockTableForAdmin({ data: Filter, page: newPage }));
			navigate(`/managearticle/?page=${newPage}`);
		}
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			const newPage = currentPage - 1;
			setCurrentPage(newPage);
			dispatch(getFetchStockTableForAdmin({ data: Filter, page: newPage }));
			navigate(`/managearticle/?page=${newPage}`);
		}
	};
	// Handle page number click
	const handlePageNumberClick = (page) => {
		if (page === currentPage) return;
		setCurrentPage(page);
		dispatch(getFetchStockTableForAdmin({ page: page, data: Filter }));

		navigate(`/managearticle/?page=${page}`);
	};

	const generatePageNumbers = () => {
		const pages = [];
		const visiblePages = 5;

		if (totalPages <= visiblePages) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(i);
			}
		} else {
			pages.push(1);
			const startPage = Math.max(2, currentPage - 2);
			const endPage = Math.min(totalPages - 1, currentPage + 2);
			if (startPage > 2) {
				pages.push('...');
			}
			for (let i = startPage; i <= endPage; i++) {
				pages.push(i);
			}
			if (endPage < totalPages - 1) {
				pages.push('...');
			}
			pages.push(totalPages);
		}

		return pages;
	};

	const openCatalogModal = (Id) => {
		setCatalogImages([]);
		setIsCatalogModalOpen(true);

		dispatch(getFetchCatalogImage({ ProductId: Id })).then((response) => {
			const images = response?.payload?.catalogImages;
			if (Array.isArray(images)) {
				setCatalogImages(images);
			} else {
				setCatalogImages([]); // Fallback to an empty array
			}
		});
	};

	const closeCatalogModal = () => {
		setIsCatalogModalOpen(false);
		setCatalogImages([]); // Reset on close
	};

	// Delete selected images
	const handleDelete = () => {
		deleteSelectedImages(selectedImages); // Pass selected images to parent for deletion
		setSelectedImages([]); // Reset selection
		// setIsEditing(false);
	};
	// Function to delete selected images
	const deleteSelectedImages = (selectedImages) => {
		setCatalogImages((prevImages) => prevImages.filter((img) => !selectedImages.includes(img)));
	};

	const toggleRow = (ArticleCode) => {
		setStockDetails((prev) =>
			prev.includes(ArticleCode)
				? prev.filter((item) => item !== ArticleCode)
				: [...prev, ArticleCode]
		);

		// Set selected ArticleCode for submission
		setSelectedArticleCode(ArticleCode);

		// Fetch stock details if expanding and not already fetched
		if (!stockDetails.includes(ArticleCode) && !designData[ArticleCode]) {
			dispatch(getFetchStockDetailTableForAdmin({ ArticleCode })).then((response) => {
				setDesignData((prev) => ({
					...prev,
					[ArticleCode]: response?.payload?.StockDetail || [],
				}));
			});
		}
	};

	const [isOpen, setIsOpen] = useState(false);
	const [toggleId, setToggleid] = useState(null);
	const [toggleStatus, setToggleStatus] = useState(null);
	const openDisplayModal = (ArticleCode, IsDisplayOnPortal) => {
		setToggleid(ArticleCode);
		setToggleStatus(IsDisplayOnPortal === true ? 0 : 1);
		setIsOpen(true);
	};

	const handleToggleDisplay = async (ArticleCode, displayStatus) => {
		try {
			// Send displayStatus as 1 (ON) or 0 (OFF)
			const response = await axios.post(
				`${API_URL}/addStock/showdisplayOnPortal`,
				{
					ArticleCode: ArticleCode,
					Value: displayStatus, // 1 or 0
				},
				config
			);

			if (response.data.success) {
				toast.success(`Product display status updated successfully!`);
				// Refetch stock data after toggling
				dispatch(getFetchStockTableForAdmin({ page: currentPage, data: Filter }));
			} else {
				toast.error('Failed to update display status.');
			}
		} catch (error) {
			console.error('Error toggling display status:', error);
			toast.error('Error toggling display status.');
		}
		closeDisplayModal();
	};

	const closeDisplayModal = () => setIsOpen(false);

	// Add New design
	const [image, setImage] = useState(null);
	const [showModal, setShowModal] = useState(false);

	const [filteredColorOptions, setFilteredColorOptions] = useState([]);
	const { Color } = useSelector((state) => state.stock);
	const [showColorDropdown, setShowColorDropdown] = useState(false);
	const [shouldShowAddNewColor, setShouldShowAddNewColor] = useState(false);
	const [filteredSizeOptions, setFilteredSizeOptions] = useState([]);
	const { Size } = useSelector((state) => state.stock);
	const [showSizeDropdown, setShowSizeDropdown] = useState(false);
	const [shouldShowAddNewSize, setShouldShowAddNewSize] = useState(false);
	const [selectedArticleCode, setSelectedArticleCode] = useState(null);

	const fileInputRef = useRef(null);

	const handleColorChange = (e) => {
		const value = e.target.value;
		setProductData({ ...productData, Color: value });

		const filtered = Color.filter((c) => c.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredColorOptions(filtered);

		setShouldShowAddNewColor(
			value.trim() !== '' &&
				!filtered.some((c) => c.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowColorDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectColor = (c) => {
		setProductData({ ...productData, Color: c.MasterValue });
		setFilteredColorOptions([]);
		setShowColorDropdown(false);
	};

	const handleSizeChange = (e) => {
		const value = e.target.value;
		setProductData({ ...productData, Size: value });

		const filtered = Size.filter((s) => s.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredSizeOptions(filtered);

		setShouldShowAddNewSize(
			value.trim() !== '' &&
				!filtered.some((s) => s.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowSizeDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectSize = (s) => {
		setProductData({ ...productData, Size: s.MasterValue });
		setFilteredSizeOptions([]);
		setShowSizeDropdown(false);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (!/^\d{0,5}$/.test(value) && (name === 'MRP' || name === 'Discount' || name === 'Qty')) {
			return; // Do not allow invalid input
		}
		setProductData((prevData) => {
			const updatedData = {
				...prevData,
				[name]: value,
			};

			// If MRP or Discount changes, perform the logic calculation
			if (name === 'Discount' || name === 'MRP' || name === 'DiscountType') {
				const mrpValue = parseFloat(updatedData.MRP) || 0;
				let discountValue = parseFloat(updatedData.Discount) || 0;

				if (updatedData.DiscountType === 'P') {
					// Convert percentage to rupees
					discountValue = (discountValue / 100) * mrpValue;
				}

				// Ensure discount is not more than MRP
				if (discountValue > mrpValue) {
					toast.error('Discount cannot be greater than MRP.');
					discountValue = mrpValue; // Set it to MRP to avoid negative values
				}

				// Calculate DiscountMRP
				updatedData.DiscountMRP = mrpValue - discountValue;
			}

			return updatedData;
		});
	};

	useEffect(() => {
		if (Color.length === 0 && !hasFetched) {
			dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
			setHasFetched(true);
		}
	}, [dispatch, Color, hasFetched]);

	useEffect(() => {
		if (Size.length === 0 && !hasFetched) {
			dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
			setHasFetched(true);
		}
	}, [dispatch, Size, hasFetched]);

	const [showImage, setShowImage] = useState(null);

	const handleDesignImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setImage(file);
			const imageURL = URL.createObjectURL(file);
			setShowImage(imageURL);
		}
	};

	useEffect(() => {
		return () => {
			if (showImage) {
				URL.revokeObjectURL(showImage);
			}
		};
	}, [showImage]);

	const [productData, setProductData] = useState({
		ArticleCodeId: '',
		Color: '',
		Size: '',
		Qty: '',
		MRP: '',
		DiscountMRP: '',
		Discount: '',
		DiscountType: '',
		ImagePath: '',
		CreatedBy: 1,
	});

	const [DropdownData, setDropdownData] = useState({
		MasterType: '',
		MasterValue: '',
	});

	const handleDropdownChange = (e) => {
		const { name, value } = e.target;
		const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

		setDropdownData((prevData) => ({
			...prevData,
			[name]: formattedValue,
		}));
	};

	const handleSubmitDropdown = async (e) => {
		e.preventDefault();

		if (!DropdownData.MasterType || !DropdownData.MasterValue) {
			return toast.error('Please fill in all fields.');
		}

		const uploadData = new FormData();
		uploadData.append('MasterType', DropdownData.MasterType);
		uploadData.append('MasterValue', DropdownData.MasterValue);

		const data = {
			MasterType: DropdownData.MasterType,
			MasterValue: DropdownData.MasterValue,
		};

		try {
			const response = await axios.post(`${API_URL}/addStock/addDropdown`, data, formConfig);
			if (response?.data?.success) {
				if (DropdownData.MasterType === 4) {
					dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
				} else if (DropdownData.MasterType === 7) {
					dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
				}

				toast.success(response?.data?.message);
				setDropdownData({ MasterType: '', MasterValue: '' });

				handleCloseModal();
			} else {
				toast.error(response?.data?.message || 'Unexpected error.');
			}
		} catch (error) {
			toast.error(error?.response?.data?.message || 'An error occurred.');
		}
	};

	const handleModal = (masterType) => {
		setDropdownData({
			MasterType: masterType,
			MasterValue: '',
		});
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
		setDropdownData({
			MasterType: '',
			MasterValue: '',
		});
	};

	const handleAddDesign = async (e) => {
		try {
			e.preventDefault();

			if (!selectedArticleCode) {
				toast.error('Please select an Article Code before adding stock.');
				return;
			}

			const form = new FormData();
			form.append('ArticleCodeId', selectedArticleCode);
			form.append('Color', productData.Color);
			form.append('Size', productData.Size);
			form.append('Qty', productData.Qty);
			form.append('MRP', productData.MRP);
			form.append('DiscountMRP', productData.DiscountMRP);
			form.append('Discount', productData.Discount);
			form.append('DiscountType', productData.DiscountType);
			form.append('CreatedBy', productData.CreatedBy || 1);

			if (image) {
				form.append('ImagePath', image);
			} else if (productData.ImagePath) {
				form.append('ImagePath', productData.ImagePath);
			}

			const response = await axios.post(`${API_URL}/addStock/addDesigns`, form, formConfig);

			if (response.data.success) {
				toast.success(response.data.message || 'Stock added successfully');

				setTimeout(() => {
					setAddDesign(false);
				}, 100);

				setProductData({
					ArticleCodeId: '',
					Color: '',
					Size: '',
					Qty: '',
					MRP: '',
					DiscountMRP: '',
					Discount: '',
					DiscountType: '',
					CreatedBy: 1,
					ImagePath: null,
					image: null,
				});

				if (fileInputRef.current) fileInputRef.current.value = '';

				dispatch(getFetchStockDetailTableForAdmin({ ArticleCode: selectedArticleCode })).then(
					(response) => {
						setDesignData((prev) => ({
							...prev,
							[selectedArticleCode]: response?.payload?.StockDetail || [],
						}));
					}
				);
			}
		} catch (error) {
			console.error('Error adding stock:', error);
			toast.error(error?.response?.data?.message || 'Something went wrong.');
		}
	};

	const [isDelete, setIsDelete] = useState(false);
	const [selectedDesignId, setSelectedDesignId] = useState(null);

	const openDeleteModal = (Id) => {
		setSelectedDesignId(Id);
		setIsDelete(true);
	};

	const closeDeleteModal = () => {
		setIsDelete(false);
		setSelectedDesignId(null);
	};

	const handleDesignDelete = async () => {
		if (!selectedDesignId) return;

		try {
			const response = await dispatch(deleteArticleDesignById(selectedDesignId)).unwrap();

			if (response.success) {
				toast.success('Design deleted successfully!');

				setTimeout(() => {
					setIsDelete(false);
				}, 100);

				// Fetch updated data after deletion
				await dispatch(getFetchStockDetailTableForAdmin({ ArticleCode: selectedArticleCode })).then(
					(response) => {
						setDesignData((prev) => ({
							...prev,
							[selectedArticleCode]: response?.payload?.StockDetail || [],
						}));
					}
				);
			} else {
				toast.error(response.message || 'Failed to delete Design');
			}
		} catch (error) {
			toast.error('Error deleting Design');
		}
	};

	return (
		<div className=' p-6'>
			<FilterSectionStoke
				Filter={Filter}
				setFilter={setFilter}
				handleStokeFilter={handleStokeFilter}
				handleReset={handleReset}
				currentPath={currentPath}
			/>
			<div>
				<table className='min-w-full bg-white table-auto lg:text-base text-sm max-[400px]:text-xs'>
					<thead>
						<tr className='w-full bg-gray-100'>
							<th className='py-1 px-4'>Image</th>
							<th className='py-1 px-4'>Article Code</th>
							<th className='py-3 px-4'>Product Name</th>
							<th className='py-3 px-4'>All Stock Qty</th>
							<th className='py-3 px-4'>Category</th>
							<th className='py-3 px-4'>Sub-Category</th>
							<th className='py-3 px-4 text-left'>Display</th>
							<th className='py-3 px-4'>Show Design</th>
						</tr>
					</thead>
					<tbody>
						{isTableLoading ? (
							<Skeleton />
						) : (
							allStock?.map((item, index) => (
								<React.Fragment key={index}>
									<tr key={index} className='border-b '>
										<td className='text-center py-2'>
											<img
												// src={`${ACTUAL_IMAGE_URL}/${item.ParentImagePath}`}
												src={`${COMPRESSED_IMAGE_URL}/${item.ParentImagePath}`}
												alt={item.ArticleCode}
												className='w-16 h-16 object-cover cursor-pointer mx-auto'
												onClick={() => handleParentImageClick(item.ParentImagePath, item.Id)}
											/>
										</td>
										<td className='py-3 px-4 text-center'>{item.ArticleCode}</td>
										<td className='py-3 px-4 text-center'>{item.ProductName}</td>
										<td className='py-3 px-4 text-center'>{item.AllStockQty}</td>
										<td className='py-3 px-4 text-center'>{item.Category}</td>
										<td className='py-3 px-4 text-center'>{item.SubCategory}</td>
										<td>
											<label className='flex cursor-pointer'>
												<input
													type='checkbox'
													checked={item.IsDisplayOnPortal === true}
													onChange={() =>
														openDisplayModal(item.ArticleCode, item.IsDisplayOnPortal)
													}
													className='toggle-checkbox hidden'
												/>
												<span
													className={`toggle-label block w-12 h-6 rounded-full ${
														item.IsDisplayOnPortal === true ? 'bg-blue-500' : 'bg-gray-300'
													} relative`}>
													<span
														className={`absolute left-0 top-0 bg-white w-6 h-6 rounded-full transition-transform duration-300 ${
															item.IsDisplayOnPortal === true ? 'transform translate-x-6' : ''
														}`}
													/>
												</span>
												<span className='ml-2'>
													{item.IsDisplayOnPortal === true ? 'ON' : 'OFF'}
												</span>
											</label>
										</td>
										<td className='py-3 px-4 text-center'>
											<IoIosArrowDown
												className={`text-xl border border-gray-950 rounded transition-all duration-300 ease-in-out inline-block cursor-pointer ${
													stockDetails.includes(item.ArticleCode) ? 'rotate-180 bg-gray-200' : ''
												} hover:scale-110 hover:shadow-md`}
												onClick={() => toggleRow(item.ArticleCode)}
											/>
										</td>
									</tr>

									{stockDetails?.includes(item.ArticleCode) && (
										<>
											<tr className=' bg-[#FAF9F6]'>
												<td colSpan='9' className='text-center py-1'>
													<div className=' flex flex-row justify-between items-center px-5'>
														<div className=' underline font-semibold'>{item.ProductName}</div>
														<div>
															<button
																onClick={addDesignModal}
																className='bg-blue-500 text-sm text-white px-3 py-2 font-medium rounded flex flex-row justify-center items-center gap-1'>
																Add Design <RiPlayListAddFill className=' text-base' />
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr className='w-full bg-[#FAF9F6]'>
												<td colSpan='9'>
													<div className=' px-2 py-1 transition-all duration-300'>
														<table className='w-full '>
															<thead>
																<tr className=' bg-[#C0C0C0] bg-opacity-50 '>
																	<th className='py-2 px-3'>Thumbnail</th>
																	<th className='py-2 px-3 '>Color</th>
																	<th className='py-2 px-3 '>Size</th>
																	<th className='py-2 px-3 '>Qty</th>
																	<th className='py-2 px-3 '>MRP</th>
																	<th className='py-2 px-3 '>Discount </th>
																	<th className='py-2 px-3 '>Discount MRP</th>
																	<th className=''>Catalog Images</th>
																	<th className=''>Delete Design</th>
																</tr>
															</thead>
															<tbody>
																{designData[item.ArticleCode]?.length > 0 ? (
																	designData[item.ArticleCode]?.map((design, designIndex) => (
																		<tr key={designIndex} className='text-center border-b'>
																			<td className='flex justify-center items-center'>
																				<img
																					// src={design.ImagePath}
																					src={`${COMPRESSED_IMAGE_URL}/${design.ImagePath}`}
																					// src={`${ACTUAL_IMAGE_URL}/${design.ImagePath}`}
																					alt='Thumbnail'
																					className=' w-16 h-16 object-cover cursor-pointer mx-auto'
																					onClick={() =>
																						handleImageClick(design.ImagePath, design.Id)
																					}
																				/>
																			</td>
																			<td className=' py-2 px-3'>{design.Color}</td>
																			<td className=' py-2 px-3'>{design.Size}</td>
																			<td className=' py-2 px-3'>{design.Qty}</td>
																			<td className=' py-2 px-3'>
																				<span className='font-serif'>₹</span>
																				{design.MRP}
																			</td>
																			<td className=' py-2 px-3'>
																				{item.DiscountType === 'R' ? (
																					<>
																						<span className='font-serif'>₹</span>
																						{design.Discount}
																					</>
																				) : design.DiscountType === 'P' ? (
																					<>
																						{design.Discount}
																						<span>%</span>
																					</>
																				) : (
																					design.Discount
																				)}
																			</td>
																			<td className=' py-2 px-3'>
																				<span className='font-serif'>₹</span>
																				{design.DiscountMRP}
																			</td>
																			<td className='text-center '>
																				<IoEye
																					className='text-blue-500 text-2xl inline-block cursor-pointer'
																					onClick={() => openCatalogModal(design.Id)}
																				/>
																			</td>
																			<td className='text-center'>
																				<AiFillDelete
																					className='text-red-500 text-2xl hover:text-red-600 inline-block cursor-pointer'
																					onClick={() => openDeleteModal(design.Id)}
																				/>
																			</td>
																		</tr>
																	))
																) : (
																	<tr>
																		<td colSpan='8' className='text-center'>
																			No designs available
																		</td>
																	</tr>
																)}
															</tbody>
														</table>
													</div>
												</td>
											</tr>
										</>
									)}
								</React.Fragment>
							))
						)}
					</tbody>
				</table>
				{allStock?.length === 0 && (
					<div className='flex flex-col justify-center items-center'>
						<img
							src={no_article}
							alt='Empty Cart'
							className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
						/>
					</div>
				)}
			</div>

			<div className=' flex justify-center items-center flex-row mt-5 gap-2 '>
				{currentPage > 1 && (
					<button
						onClick={handlePrevPage}
						className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
						<FaChevronLeft />
					</button>
				)}

				<div className='space-x-2'>
					{generatePageNumbers().map((page, index) =>
						typeof page === 'number' ? (
							<button
								key={index}
								onClick={() => handlePageNumberClick(page)}
								className={`px-3 py-1 border rounded text-base font-semibold ${
									page === currentPage ? 'bg-[#EF4444] text-white' : 'bg-gray-200 hover:bg-gray-300'
								}`}>
								{page}
							</button>
						) : (
							<span key={index} className='text-gray-500'>
								...
							</span>
						)
					)}
				</div>

				{currentPage < totalPages && (
					<button
						onClick={handleNextPage}
						className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
						<FaChevronRight />
					</button>
				)}
			</div>

			{modal && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white py-4 px-5 rounded-md  w-[310px] md:w-[220px] lg:w-[350px] relative'>
						<ImCancelCircle
							onClick={handlecloseModal}
							className='text-red-500 absolute top-2 right-4 text-[32px] font-bold cursor-pointer'
						/>
						{!imageDetails.showImage && (
							<div className='flex items-center justify-center'>
								<img
									// src={`${COMPRESSED_IMAGE_URL}/${imageDetails.currentImage}`}
									src={`${ACTUAL_IMAGE_URL}/${imageDetails.currentImage}`}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:w-[320px] object-cover'
								/>
							</div>
						)}
						{/* {imageDetails.showImage && (
							<div className='flex items-center justify-center flex-col'>
								<img
									src={imageDetails.currentImage}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:[320px] object-cover'
								/>
							</div>
						 )} */}
						<div className='lg:mt-5 mt-2 flex flex-col  items-center justify-center gap-2'>
							{/*<input
								type='file'
								accept='image/*'
								onChange={handleImageChange}
								placeholder='Enter'
								className=' w-[250px] md:w-[180px] lg:[320px] object-cover'
							/>*/}
							<button
								onClick={handlecloseModal}
								className='w-full  text-white bg-red-500 px-3 py-2 font-semibold text-sm rounded-md'>
								Close
							</button>
						</div>
					</div>
				</div>
			)}

			{parentImageModal && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white py-4 px-5 rounded-md w-[310px] md:w-[220px] lg:w-[350px] relative'>
						<ImCancelCircle
							onClick={handleCloseParentModal}
							className='text-red-500 absolute top-2 right-4 text-[32px] font-bold cursor-pointer'
						/>
						{!parentImageDetails.showImage ? (
							<div className='flex items-center justify-center'>
								<img
									src={`${ACTUAL_IMAGE_URL}/${parentImageDetails.currentImage}`}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:w-[320px] object-cover'
								/>
							</div>
						) : (
							<div className='flex items-center justify-center flex-col'>
								<img
									src={parentImageDetails.currentImage}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:w-[320px] object-cover'
								/>
							</div>
						)}
						<div className='lg:mt-5 mt-2 flex flex-col items-center justify-center gap-2'>
							<input
								type='file'
								accept='image/*'
								onChange={handleParentImageChange}
								className='w-[250px] md:w-[180px] lg:w-[320px]'
							/>
							<button
								onClick={() => handleParentImageSubmit(parentImageDetails.Id)}
								className='w-full text-white bg-red-500 px-3 py-2 font-semibold text-sm rounded-md'>
								Save
							</button>
						</div>
					</div>
				</div>
			)}

			{isCatalogModalOpen && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white py-4 px-5 rounded-md   relative'>
						<button
							onClick={closeCatalogModal}
							className=' z-10 absolute right-0 top-0 md:w-20 md:h-20 w-16 h-16 rounded-tr-md rounded-bl-full shadow-xl bg-red-500 hover:bg-red-600 transition-colors duration-300 text-center'>
							<ImCross className='text-white absolute md:right-5 right-4 md:text-lg text-base md:top-5 top-4 text-center' />
						</button>
						<h2 className='text-lg font-semibold mb-3'> Catalog Images</h2>

						<div className='flex flex-wrap justify-start gap-2 max-h-[600px] overflow-y-auto p-2 max-w-5xl custom-scrollbar'>
							{Array.isArray(catalogImages) && catalogImages.length > 0 ? (
								catalogImages.map((img, index) => (
									<div key={index} className='relative group'>
										<img
											src={`${COMPRESSED_IMAGE_URL}/${img.CatalogueImagePath}`}
											alt='Product'
											className='w-[250px] md:w-[180px] lg:w-[320px] rounded-sm object-cover'
										/>
										<button
											onClick={() => handleDelete(img.Id)}
											className='absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
											{/* Delete Button */}
										</button>
									</div>
								))
							) : (
								<tr>
									<td colSpan='8' className='text-center '>
										<div className=' flex justify-center items-center flex-col w-72'>
											<MdImageNotSupported className=' text-8xl text-red-400' />
											<p className=''>No Images available</p>
										</div>
									</td>
								</tr>
							)}
						</div>
					</div>
				</div>
			)}

			{isOpen && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-md md:w-[500px] w-[90%]'>
						<h2 className='text-xl font-semibold mb-4'>Confirmation</h2>
						<p className='mb-6'>
							Are you sure you want to change the toggle switch to{' '}
							<strong>{toggleStatus === '1' ? 'ON' : 'OFF'}</strong>?
						</p>
						<div className='flex justify-between'>
							<button
								onClick={closeDisplayModal}
								className='bg-gray-100 text-yellow-500 px-4 py-2 rounded-md'>
								Cancel
							</button>
							<button
								onClick={() => handleToggleDisplay(toggleId, toggleStatus)}
								className='bg-red-500 text-white px-4 py-2 rounded-md'>
								Confirm
							</button>
						</div>
					</div>
				</div>
			)}

			{showModal && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-md w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] relative'>
						<ImCancelCircle
							onClick={handleCloseModal}
							className='text-red-500 absolute right-3 top-3 text-2xl font-bold cursor-pointer'
						/>
						<form onSubmit={handleSubmitDropdown}>
							<div className='mt-3'>
								<input
									type='text'
									name='MasterValue'
									value={DropdownData.MasterValue}
									onChange={handleDropdownChange}
									className='w-full bg-gray-100 text-gray-900 mt-3 mb-4 p-3 focus:shadow-outline border-[0.25px] rounded-md'
									placeholder='Enter New Dropdown Value'
								/>
							</div>
							<div className='mt-4 flex justify-end'>
								<button
									type='submit'
									className='w-full sm:w-auto text-white bg-red-500 px-4 py-3 font-semibold text-sm rounded-md'>
									Save
								</button>
							</div>
						</form>
					</div>
				</div>
			)}

			{addDesign && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-30'>
					<div className='bg-white py-4 px-5 rounded-md relative w-1/2 '>
						<button
							onClick={closeAddDesignModal}
							className='z-10 absolute right-0 top-0 md:w-20 md:h-20 w-16 h-16 rounded-tr-md rounded-bl-full shadow-xl bg-red-500 hover:bg-red-600 transition-colors duration-300 text-center'>
							<ImCross className='text-white absolute md:right-5 right-4 md:text-lg text-base md:top-5 top-4 text-center' />
						</button>
						<div className='    '>
							<form onSubmit={handleAddDesign} className=' w-full'>
								<div className=' flex flex-row gap-2'>
									{/* <div className=' border-2 bg-white bg-opacity-5 py-5 px-10 shadow-lg rounded-lg  w-[55%]'></div> */}
									{/* design form */}
									<div className='   '>
										<p className=' font-medium md:text-xl sm:text-lg text-base mb-1'>
											Add Article Designs
										</p>
										<div className=' border-[1px] border-black sm:mb-8 mb-6 sm:w-12 w-10 ' />
										<div className='grid grid-cols-1 gap-6 mb-6'>
											<div className=' flex flex-row w-full gap-4'>
												<div className='flex flex-col relative w-full'>
													<label className='text-sm font-medium mb-1'>Color</label>
													<div className=' flex flex-row  items-center'>
														<div className=' w-full'>
															<input
																name='Color'
																type='text'
																className='border rounded p-2 w-full'
																placeholder='Search Color'
																value={productData.Color}
																onChange={handleColorChange}
																autoComplete='off'
															/>
														</div>
														<div className='relative inline-block group'>
															{/* Button with hover effect */}
															<button type='button' onClick={() => handleModal(4)} className=''>
																<IoAddCircle className=' text-[44px] hover:text-green-600 text-green-500' />
															</button>

															{/* Tooltip that appears on hover */}
															<div className='absolute md:top-[40px] z-20 max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
																Add New Color
															</div>
														</div>
													</div>
													{showColorDropdown && productData?.Color?.trim() !== '' && (
														<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
															{filteredColorOptions.length > 0 ? (
																filteredColorOptions.map((c) => (
																	<div
																		key={c.MasterValue}
																		className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																		onClick={() => selectColor(c)}>
																		{c.MasterValue}
																	</div>
																))
															) : (
																<div className='z-0'></div>
															)}

															{shouldShowAddNewColor && (
																<div
																	className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																	onClick={() => handleModal(4)}>
																	+ Add this as new color: &quot;{productData.Color}&quot;
																</div>
															)}
														</div>
													)}
												</div>

												<div className='flex flex-col relative w-full'>
													<label className='text-sm font-medium mb-1'>Size:</label>
													<div className=' flex flex-row  items-center'>
														<div className=' w-full'>
															<input
																type='text'
																name='Size'
																className='border rounded p-2 w-full'
																placeholder='Search Size'
																value={productData.Size}
																onChange={handleSizeChange}
																autoComplete='off'
															/>
														</div>
														<div className='relative inline-block group'>
															<button type='button' onClick={() => handleModal(7)} className=''>
																<IoAddCircle className='text-[44px] hover:text-green-600 text-green-500' />
															</button>

															<div className='absolute z-20 md:top-[40px] max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
																Add New Size
															</div>
														</div>
													</div>

													{showSizeDropdown && productData?.Size?.trim() !== '' && (
														<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
															{filteredSizeOptions.length > 0 ? (
																filteredSizeOptions.map((s) => (
																	<div
																		key={s.MasterValue}
																		className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																		onClick={() => selectSize(s)}>
																		{s.MasterValue}
																	</div>
																))
															) : (
																<div className='z-0'></div>
															)}

															{shouldShowAddNewSize && (
																<div
																	className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																	onClick={() => handleModal(7)}>
																	+ Add this as new Size: &quot;{productData.size}&quot;
																</div>
															)}
														</div>
													)}
												</div>
											</div>
											<div className=' flex flex-row w-full gap-4'>
												<div className='flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Price:</label>
													<input
														name='MRP'
														value={productData.MRP}
														onChange={handleChange}
														type='number'
														className='border rounded p-2 w-full'
														placeholder='Enter Price'
													/>
												</div>

												<div className='flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Discount:</label>
													<input
														type='number'
														name='Discount'
														value={productData.Discount}
														onChange={handleChange}
														className='border rounded p-2 w-full'
														placeholder='Enter Discount'
													/>
												</div>
												<div className='flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Discount:</label>

													<select
														name='DiscountType'
														value={productData.DiscountType}
														onChange={handleChange}
														className='border rounded p-2 w-full bg-white font-serif'>
														<option value=''>Select Discount Type</option>
														<option value='P'>Percentage (%) </option>
														<option value='R'>Rupees (₹)</option>
													</select>
												</div>

												<div className='flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Discount MRP:</label>
													<input
														type='text'
														name='DiscountMRP'
														value={productData.DiscountMRP}
														className='border rounded p-2 w-full'
														placeholder='Discount MRP'
														readOnly
													/>
												</div>
											</div>
											<div className=' flex flex-row w-full gap-4'>
												<div className=' flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Quantity:</label>
													<input
														type='text'
														name='Qty'
														value={productData.Qty}
														onChange={handleChange}
														className='border rounded p-2 w-full'
														placeholder=' Enter Quantity'
													/>
												</div>
												<div className='flex flex-row w-full gap-4 '>
													<div className=' flex flex-col w-full'>
														<label className='text-sm font-medium mb-1'>Add Thumbnail</label>
														<input
															className='border rounded p-2 w-full'
															type='file'
															accept='image/*'
															onChange={handleDesignImageChange}
															ref={fileInputRef}
														/>
													</div>
													{showImage && (
														<div>
															<img
																src={showImage}
																className='w-16 h-16 md:w-24 md:h-24 object-cover cursor-pointer mt-2'
																alt='Preview'
															/>
														</div>
													)}
												</div>
											</div>
											<div className='flex items-center gap-5 w-full'>
												{/* <button
													onClick={addItem}
													className='bg-blue-500 text-white px-4 py-2 rounded w-fit flex flex-row justify-center items-center gap-2'>
													Add Design <RiPlayListAddFill />
												</button> */}
											</div>
										</div>
									</div>
								</div>
								{/* Table Section */}
								<button className=' mt-3 proBtn rounded-md w-36' type='submit'>
									Save
								</button>
							</form>
						</div>
					</div>
				</div>
			)}

			{isDelete && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-md md:w-[500px] w-[90%]'>
						<h2 className='text-xl font-semibold mb-4'>Confirmation</h2>
						<p className='mb-6'>Are you sure you want to delete this Design?</p>
						<div className='flex justify-between'>
							<button
								onClick={closeDeleteModal}
								className='bg-gray-100 text-yellow-500 px-4 py-2 rounded-md'>
								Cancel
							</button>
							<button
								onClick={handleDesignDelete}
								className='bg-red-500 text-white px-4 py-2 rounded-md'>
								Confirm
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ManageArticle;
